export default __webpack_public_path__ + "static/media/not-found.e70bc687.svg";